export const VALIDATE_LINE_TOKEN_SUCCESS = 'VALIDATE_LINE_TOKEN_SUCCESS';
export const VALIDATE_LINE_TOKEN_ERROR = 'VALIDATE_LINE_TOKEN_ERROR';
export const RESET_LINE_TOKEN_STATE = 'RESET_LINE_TOKEN_STATE';
export const RETRIEVE_LINE_TOKEN_ERROR = 'RETRIEVE_LINE_TOKEN_ERROR';
export const SUBMIT_LINE_TOKEN = 'SUBMIT_LINE_TOKEN';
